<template>
  <div class="wrapper-notifications">
    <div class="above-info">
      <p>Notificaciones</p>
    </div>

    <div class="wrapper-form">
      <GeneralInput
        v-model:text="title.val"
        :value="title.val"
        :label="'Título'"
        :has-error="title.enabled"
        :error="title.errors.length === 0 ? '' : title.errors[0]"
      />
      <GeneralTextArea
        v-model:text="description.val"
        :value="description.val"
        :label="'Contenido'"
        :has-error="description.enabled"
        :error="description.errors.length === 0 ? '' : description.errors[0]"
      />
      <StandardButton
        :buttonLabel="'Enviar notificación'"
        class="margin-button"
        :is-disabled="successForm"
        @click="createnotificationTransaction"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import GeneralInput from "@/components/commons/controls/GeneralInput.vue";
import GeneralTextArea from "@/components/commons/controls/GeneralTextArea.vue";
import { notificationsValidator } from "@/ux/notifications/validators/notificationsValidator";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { spinnerProcessKey, successProcessKey } from "@/main";
import { notificationsUse } from "./use/notificationsUse";

export default defineComponent({
  name: "NotificationsView",
  components: {
    GeneralInput,
    GeneralTextArea,
    StandardButton,
  },

  setup(props, context) {
    const successProcess = inject(successProcessKey)!;
    const { showSuccessModal } = successProcess;

    const spinnerProcess = inject(spinnerProcessKey)!;
    const { offSpinnerState, onSpinnerState } = spinnerProcess;

    const { title, description, successForm, reset } = notificationsValidator();

    const { createNotificationOperation } = notificationsUse();

    async function createnotificationTransaction() {
      try {
        await onSpinnerState();
        await createNotificationOperation(
          title.value.val ?? "",
          description.value.val ?? ""
        );
        await offSpinnerState();
        showSuccessModal("Notificación enviada correctamente");
      } catch (exception) {
        await offSpinnerState();
        throw exception;
      }
    }

    return {
      title,
      description,
      successForm,
      reset,
      createnotificationTransaction,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/notifications/styles/notificationsStyle";
</style>
